import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import toast from "react-hot-toast";

import CustomInput from "../../../common/CustomInput";
import CustomDatePickerV2 from "../../../common/CustomDatePickerV2";
import CustomButton from "../../../common/CustomButton";
import CustomModalWrapper from "../../../common/CustomModalV2/wrapper";

import { getDateFormat, Months, validations } from "../../../constants";
import { apiCallV2 } from "../../../utils/api";
import { SetUserDetails, SetPersonalInfo } from "../../../redux/v2/user/actions";

import "../../../styles/inputs.css";

function Details(props) {
    const { next } = props;
    const { account } = props.User;

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [firstnameError, setfirstnameError] = useState("");
    const [lastnameError, setlastnameError] = useState("");
    const [selectedGender, setGender] = useState("");
    const [selectedDate, setDate] = useState("");
    const [gendererror, setGenderError] = useState("");
    const [dateerror, setDateerror] = useState("");
    const [loading, setLoading] = useState(false);

    const genderArray = ["Male", "Female", "Gender not listed", "Prefer not to say"];
    const genderValue = {
        Male: "M",
        Female: "F",
        "Gender not listed": "GNL",
        "Prefer not to say": "PNTS",
    };
    const genderKey = {
        M: "Male",
        F: "Female",
        GNL: "Gender not listed",
        PNTS: "Prefer not to say",
    };

    const onClickNext = async () => {
        if (firstName?.trim() === "") {
            setfirstnameError(validations.firstnameValidation);
        } else if (firstName?.trim().length < 2) {
            setfirstnameError(validations.firstNameLengthValidation);
        } else if (lastName?.trim() === "") {
            setlastnameError(validations.lastnameValidation);
        } else if (lastName?.trim().length < 2) {
            setlastnameError(validations.lastNameLengthValidation);
        } else if (selectedGender == "") {
            setGenderError("error");
        } else if (selectedDate == "") {
            setDateerror("error");
        } else {
            const toastId = toast.loading("Setting up account...");
            setGenderError("");
            setLoading(true);

            const details = {
                first_name: firstName,
                last_name: lastName,
                dob: getDateFormat(selectedDate),
                gender: genderValue[selectedGender],
            };

            const res = await apiCallV2("POST", "set-personal-info", details, localStorage.getItem("access-token"));

            if (res.status == 200) {
                next(toastId);
                props.SetPersonalInfo(details);
                props.SetUserDetails({
                    ...account?.user,
                    ...details,
                    requirement_status: 2,
                });
                localStorage.setItem("requirement_status", 2);

                setLoading(false);
            } else {
                setLoading(false);
            }
        }
    };

    const onBlurfirstNameInput = async (e) => {
        e.preventDefault();
        if (firstName?.trim() == "") {
            setfirstnameError(validations.firstnameValidation);
        } else if (firstName?.trim().length < 2) {
            setfirstnameError(validations.firstNameLengthValidation);
        } else {
            setfirstnameError("");
        }
    };

    const onBlurGender = async (e) => {
        e.preventDefault();
        if (selectedGender == "") {
            setGenderError(validations.GenderValidation);
        } else {
            setGenderError("");
        }
    };

    const onBlurlastNameInput = async (e) => {
        e.preventDefault();
        if (lastName?.trim() == "") {
            setlastnameError(validations.lastnameValidation);
        } else if (lastName?.trim().length < 2) {
            setlastnameError(validations.lastNameLengthValidation);
        } else {
            setlastnameError("");
        }
    };

    useEffect(() => {
        if (account?.user?.userID) {
            account?.user?.dob && setDate(new Date(account?.user?.dob));
            setFirstName(account?.user?.first_name);
            setLastName(account?.user?.last_name);
            setGender(genderKey[account?.user?.gender]);
        }
    }, [account?.user?.userID]);

    return (
        <div id="gs-v2-details">
            <h3>Let's Get to Know Each Other! </h3>
            <p>Tell us a bit about yourself so we recommend the perfect programs for you.</p>

            <form className="details-form" style={{ width: "100%" }}>
                <div className="input-field">
                    <CustomInput
                        type="text"
                        placeholder="First Name"
                        className="form-control i-box"
                        value={firstName}
                        name="inputName"
                        onChange={(e) => {
                            setFirstName(e.target.value);
                        }}
                        onBlur={(e) => {
                            onBlurfirstNameInput(e);
                        }}
                    />

                    {firstnameError != "" && <p className="errorCentered">{firstnameError}</p>}
                </div>
                <div className="input-field">
                    <CustomInput
                        type="text"
                        placeholder="Last Name"
                        value={lastName}
                        name="inputName"
                        onChange={(e) => {
                            setLastName(e.target.value);
                        }}
                        onBlur={(e) => {
                            onBlurlastNameInput(e);
                        }}
                    />
                    {lastnameError != "" && <p className="errorCentered">{lastnameError}</p>}
                </div>

                <div className="input-field">
                    <DropDownListComponent
                        onBlur={(e) => onBlurGender(e)}
                        value={selectedGender}
                        dataSource={genderArray}
                        placeholder="Gender"
                        className="field"
                        onChange={(e) => {
                            setGender(e.target.value);
                        }}
                    />
                    {gendererror != "" && <p className="errorCentered">{"Please select gender"}</p>}
                </div>

                {/* <div className="input-field date-picker">
                    <MyDatepicker
                        max={new Date()}
                        value={selectedDate}
                        onChange={(e) => {
                            setDate(e);
                        }}
                        confirmText="Save"
                        cancelText="Cancel"
                        headerFormat="MM/DD/YYYY"
                        dateConfig={{
                            month: {
                                format: (value) => Months[value.getMonth() + 1],
                                caption: "Month",
                                step: 1,
                            },
                            date: {
                                format: "DD",
                                caption: "Day",
                                step: 1,
                            },
                            year: {
                                format: "YYYY",
                                caption: "Year",
                                step: 1,
                            },
                        }}
                    />
                </div> */}
                <div className="input-field date-picker">
                    <CustomDatePickerV2
                        value={selectedDate}
                        onChange={(e) => {
                            setDate(e);
                        }}
                    />
                </div>
            </form>
            <div>
                <CustomButton onClick={() => onClickNext()} /* onClick={next} */ disabled={!(firstName && lastName && selectedDate && selectedGender)}>
                    NEXT
                </CustomButton>
            </div>

            <CustomModalWrapper />
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    SetUserDetails,
    SetPersonalInfo,
})(Details);
